import { chakra, Heading, Icon, Text } from '@chakra-ui/react';
import { LucideAlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Wrap = chakra('div', {
  base: {
    display: 'flex',
    flexDir: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '90%',
    width: '100%',
    margin: 'auto',
    maxWidth: '500px',
    gap: '20px',
  },
});

interface ErrorViewProps {
  resetErrorBoundary?: () => void;
  view?: 'planner' | 'project' | 'zone' | 'general';
}
export const ErrorView: React.FC<ErrorViewProps> = ({ view = 'planner' }: ErrorViewProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'common.errors' });
  return (
    <Wrap>
      <Icon variant="error" size="lg">
        <LucideAlertTriangle />
      </Icon>
      <Heading>{t('heading')}</Heading>
      <Text textAlign="center">
        {t(`unrecoverable.${view}`, {
          defaultValue: 'An unrecoverable error occured with AirChef. You can try retrying by refreshing the page.',
        })}
      </Text>
    </Wrap>
  );
};
ErrorView.displayName = 'ErrorView';
